import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  insuranceTooltipContent: {
    defaultMessage: 'Insurance provider not selected within shipping configuration',
    description: 'multiPackage.disabledInsuranceField',
    id: 'lXFvQm',
  },
});
